import { Link, router, usePage } from "@inertiajs/react"
import { Bell } from "lucide-react"

import { Badge } from "@/components/ui/badge"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { mark_all_read_notifications_path } from "@/routes"

function markAllRead() {
  router.patch(mark_all_read_notifications_path(), {}, {preserveScroll: true})
}

export function NotificationBell() {
  const {notifications} = usePage().props

  return (
    <Popover>
      <PopoverTrigger
        aria-label="Notifications"
        className="relative rounded-full p-2 hover:bg-accent"
      >
        <Bell className="size-5" />
        {notifications.unread_count > 0 && (
          <Badge className="absolute -right-1 -top-1 h-4 min-w-4 justify-center px-1 text-[10px]">
            {notifications.unread_count}
          </Badge>
        )}
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium">Notifications</span>
          {notifications.unread_count > 0 && (
            <button
              type="button"
              onClick={markAllRead}
              className="text-xs text-muted-foreground hover:underline"
            >
              Mark all as read
            </button>
          )}
        </div>

        {notifications.recent.length === 0 && (
          <p className="text-sm text-muted-foreground">No notifications yet.</p>
        )}

        <div className="flex flex-col gap-1">
          {notifications.recent.map((notification) => (
            <Link
              key={notification.id}
              href={notification.url}
              className={`rounded-md p-2 text-sm hover:bg-accent ${
                notification.read ? "text-muted-foreground" : "font-medium"
              }`}
            >
              {notification.message}
            </Link>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  )
}
